export const UNLINK_EXPENSIFY = 'unlink-expensify';
const unlinkExpensify = () => ({ type: UNLINK_EXPENSIFY });
export default unlinkExpensify;
